import {Fragment, useState} from 'react';

import {RoleService as Service} from './RoleService';

import {useToolbar} from '../../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../../shared/hooks/DataTable';
import {useDialogCreate} from './component/Create';

export const List = () => {

  const header = 'Nhóm quyền';
  const dataKey = 'id';
  const [group, setGroup] = useState(null);
  const [idUpdate, setIdUpdate] = useState(null);
  
  const {render: renderDataTable, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'name', header: 'Tên nhóm quyền', matchMode: 'contains', style: {minWidth: '250px'}},
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      if(params['name']){
        params = {...params, filter: params['name']}
      }
      if(params['sorting']){
        params = {...params, sorting: params['sorting'] + ' ' + (params['sortType'] === 'ASCEND' ? 'asc' : 'desc')}
      }
      return Service.getList(params);
    }
  });

  const {render: renderDialogCreate, show: showDialogCreate, update, create, copy} = useDialogCreate({
    group,
    reloadLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey,
    create: create,
    update: update,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    reloadLazyData,
    selectedItems,
    otherActions: [
      {
        label: "Sao chép",
        icon: "pi pi-fw pi-copy",
        className: "iam-toolbar",
        command: () => {
          if (selectedItems && selectedItems['id']) {
            copy(selectedItems);
          } 
        }
      },
    ],
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCreate()}
    </Fragment>
  )
}
